export const PILOT_DETAILS_CARD_FRENCH_LOCALE = {
  title: "Détails du pilote",
  location: "Localisation",
  serialNumber: "Numéro de série",
  siteId: "Site Id",
  hardwareId: "Hardware Id",
  csId: "Cs Id",
  softwareVersion: "Version logicielle",
  operator: "Opérateur",
};
